<template>
    <vx-card no-shadow>
        <div>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <span v-for="(object, index) in objects" :key="index">
                        <vs-button @click.stop="onClickObject(object)" class="mr-2 mb-2" type="border">
                            {{ object.name }}
                        </vs-button>
                    </span>
                </div>
            </div>

            <vs-table max-items="20" pagination :data="records" id="object-data" stripe :sst="true">

                <template slot="header">
                    <div class="vx-row mt-8">
                        <div class="vx-col w-full">
                            <h3 class="mb-4">{{ selected_object && selected_object.name ? selected_object.name : '' }}
                                ({{ records.length }} Records)</h3>
                            <vs-input @input="handleSearch" v-model="searchQuery" class="w-64" placeholder="Search Name"></vs-input>
                        </div>
                    </div>
                </template>

                <template slot="thead">
                    <vs-th width="30%">ID</vs-th>
                    <vs-th width="70%">NAME</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].Id">
                            {{ data[indextr].Id }}
                        </vs-td>

                        <vs-td :data="data[indextr].Name">
                            {{ data[indextr].Name }}
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </vx-card>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const SalesforceRepository = RepositoryFactory.get('sf')

const TenantRepository = RepositoryFactory.get('tenant')
const IncotermRepository = RepositoryFactory.get('incoterm');
const CcpRepository = RepositoryFactory.get('ccp');
const StaffRepository = RepositoryFactory.get('staff');
const BankAccountRepository = RepositoryFactory.get('bank_account');

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

export default {
    name: 'TestAiEngine',
    data() {
        return {
            records: [],
            selected_object: {},
            searchQuery: '',
            objects: [
                { name: 'Company', value: 'Account' },
                { name: 'Contact', value: 'Contact' },
                { name: 'Location', value: 'Site_Location__c' },
                { name: 'Building', value: 'Building__c' },
                { name: 'Standard Actions', value: 'ActionTitle__c' },
                { name: 'Action (Recommendations)', value: 'Recommendations__c' },
                { name: 'Property Risk Assessment', value: 'PropertyRiskAssessment__c' },
                { name: 'Hazard Inspection', value: 'HazardInspection__c' },
                { name: 'COPE Assessment', value: 'COPE_Assessment__c' },
                { name: 'Recommendations__ChangeEvent', value: 'Recommendations__ChangeEvent' },
                { name: 'Recommendations__History', value: 'Recommendations__History'},
                {name: 'HazardousChemicalsandSubstances__c', value: 'HazardousChemicalsandSubstances__c'},
                {name: 'PlantMachinery__c', value: 'PlantMachinery__c'},
                {name: 'CriticalSuppliers__c', value: 'CriticalSuppliers__c'},
                {name: 'sharinpix__SharinPixAlbum__c', value: 'sharinpix__SharinPixAlbum__c' },
                {name: 'ContentDocumentLink', value: 'ContentDocumentLink'}
            ],
            selected_object: '',
            open: false,
            details: {
                Code: ''
            },
            endpoint: '',
            attachments: [],
            dragover: false,
            sortBy: 'date-desc',
            selectedFile: null,
            placeholderImgs: {}, // Track images that failed to load,
            response: null
        }
    },
    async mounted() {
        await this.fetchAllObjects()
        // await this.fetchObjectRecords();
    },
    created() {
        this.handleSearch = _.debounce(this.handleSearchImmediate, 1000)
        this.selected_object = this.objects[0]
    },
    methods: {
        async fetchObjectRecords() {
            await this.$vs.loading({
                container: '#object-data',
                scale: 0.45
            })
            try {
                const { data } = (await SalesforceRepository.fetchObjectRecords(this.selected_object.value, this.searchQuery)).data
                this.records = data
                // .filter(d => !d.IsDeleted)
            } catch (error) {

            } finally {
                this.$vs.loading.close('#object-data > .con-vs-loading')
            }
        },
        async onClickObject(object) {
            this.selected_object = object
            this.searchQuery = ''
            await this.fetchObjectRecords()
        },
        async fetchAllObjects() {
            try {
                const { data } = (await SalesforceRepository.getObjects()).data
                // this.objects = data.filter(x => x.queryable && !x.deprecatedAndHidden && x.retrieveable).map(x => x.name)
            } catch (error) {

            }
        },
        async handleSearchImmediate(searching) {
            await this.fetchObjectRecords()
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        async onUploadFile(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.$vs.loading();
            try {
                let formData = new FormData();
                formData.append('file', file);
                const data = await TenantRepository.uploadDocumentForAiEngine(formData);
                this.response = data
                //   this.$vs.notify({
                //     title: 'Success',
                //     text: 'File uploaded successfully',
                //     color: 'success'
                //   });
                // await this.fetchAttachments();
            } catch (e) {
                console.log(e);
                //   this.$vs.notify({
                //     title: 'Error',
                //     text: 'Failed to upload file',
                //     color: 'danger'
                //   });
            }
            this.$vs.loading.close();
            // Clear the input
            event.target.value = '';
        },
        onFileDrop(event) {
            this.dragover = false;
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                this.$refs.fileInput.files = files;
                this.onUploadFile({ target: this.$refs.fileInput });
            }
        },
        async fetchAttachments() {
            this.$vs.loading();
            try {
                const { data } = (await TenantRepository.getAttachments(this.endpoint, this.details._id)).data;
                this.attachments = data;
            } catch (e) {
                console.log(e);
            }
            this.$vs.loading.close();
        },
        isImageFile(fileName) {
            const ext = fileName.split('.').pop().toLowerCase();
            return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(ext);
        },
        handleImageError(event) {
            // Replace broken image with the appropriate file icon
            const target = event.target;
            const parent = target.parentElement;

            // Find the attachment by searching for the img src
            const s3KeyPath = target.src.split('amazonaws.com/')[1];
            const attachment = this.attachments.find(a => a.s3Key === s3KeyPath);

            if (attachment && parent) {
                // Add the attachment to failed images
                this.$set(this.placeholderImgs, attachment._id, true);

                // Force a re-render
                this.$forceUpdate();
            }
        },
        getFileIcon(fileName) {
            const ext = fileName.split('.').pop().toLowerCase();
            switch (ext) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'gif':
                    return 'image';
                case 'pdf':
                    return 'picture_as_pdf';
                case 'doc':
                case 'docx':
                    return 'description';
                case 'xls':
                case 'xlsx':
                    return 'table_chart';
                case 'zip':
                case 'rar':
                    return 'archive';
                default:
                    return 'insert_drive_file';
            }
        },
        getFileColorClass(fileName) {
            const ext = fileName.split('.').pop().toLowerCase();

            if (['pdf'].includes(ext)) return 'bg-red-500';
            if (['doc', 'docx'].includes(ext)) return 'bg-blue-500';
            if (['xls', 'xlsx', 'csv'].includes(ext)) return 'bg-green-500';
            if (['ppt', 'pptx'].includes(ext)) return 'bg-orange-500';
            if (['jpg', 'jpeg', 'png', 'gif', 'svg'].includes(ext)) return 'bg-purple-500';
            if (['zip', 'rar', '7z'].includes(ext)) return 'bg-yellow-500';
            if (['mp4', 'avi', 'mov'].includes(ext)) return 'bg-pink-500';

            return 'bg-gray-500';
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        },
        getFileSize(attachment) {
            // If your API returns file size, you can format it here
            // Example: if attachment.fileSize exists
            if (attachment.fileSize) {
                const kb = attachment.fileSize / 1024;
                if (kb < 1024) {
                    return `${Math.round(kb)} KB`;
                } else {
                    return `${(kb / 1024).toFixed(1)} MB`;
                }
            }
            return '';
        },
        downloadFile(attachment) {
            if (!attachment.s3Key || !attachment.fileName) {
                console.error('Missing S3 key or file name.');
                return;
            }

            // Construct the S3 download URL
            const downloadUrl = `https://ribu-production.s3.ap-southeast-2.amazonaws.com/${attachment.s3Key}`;

            const newTab = window.open(downloadUrl, '_blank');

            // Fallback: If the browser blocks the new tab (for example, if popups are blocked)
            if (!newTab) {
                console.error('Failed to open the file in a new tab. Popups may be blocked.');
            }
        }
    },
    components: {
        flatPickr,
        'v-select': vSelect,
    },
    computed: {
        selected_obj_value() {
            return this.selected_object && this.selected_object.value ? this.selected_object.value : '';
        },
        sortedAttachments() {
            return [...this.attachments].sort((a, b) => {
                if (this.sortBy === 'date-desc') {
                    return new Date(b.createdAt) - new Date(a.createdAt);
                } else if (this.sortBy === 'date-asc') {
                    return new Date(a.createdAt) - new Date(b.createdAt);
                } else if (this.sortBy === 'name') {
                    return a.fileName.localeCompare(b.fileName);
                }
                return 0;
            });
        }
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-incoterms>>>.vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
}
</style>